import { useTheme } from '@/components/ui/theme-provider';
import {
	Carousel,
	SearchBar,
	SearchContext,
	SearchContextManager,
	SuggestionBar,
} from '@giphy/react-components';
import { useContext } from 'react';

const Giphy = ({ setAttachments, toggleGiphyPicker }) => (
	<SearchContextManager apiKey={import.meta.env.VITE_GIPHY_KEY}>
		<Components
			setAttachments={setAttachments}
			toggleGiphyPicker={toggleGiphyPicker}
		/>
	</SearchContextManager>
);

// Separate components to use the context
const Components = ({ setAttachments, toggleGiphyPicker }) => {
	const { fetchGifs, searchKey } = useContext(SearchContext);

	const { resolvedTheme: theme } = useTheme();

	const giphyLogoSrc =
		theme === 'dark' ? '/img/giphy-logo-dark.png' : '/img/giphy-logo.png';

	const handleAttachGif = async (gif) => {
		toggleGiphyPicker();
		const attachment = {
			type: 'image/gif',
			size: gif.images.fixed_height.size,
			name: gif.title || 'GIF',
			mediaUrl: gif.images.fixed_height.url,
			preview: gif.images.fixed_height.url,
		};

		setAttachments((attachments) => [...attachments, attachment]);
	};

	return (
		<>
			<SearchBar />
			<div className="h-[4px]" />
			<SuggestionBar />
			<div className="h-[4px]" />
			<Carousel
				key={searchKey}
				gifHeight={200}
				gutter={6}
				fetchGifs={fetchGifs}
				onGifClick={(gif, e) => {
					e.preventDefault();
					handleAttachGif(gif);
				}}
			/>
			<img
				src={giphyLogoSrc}
				alt="Powered by Giphy"
				className="w-40 mx-auto mt-1"
			/>
		</>
	);
};

export default Giphy;
